export const formFields = {
  name: 'name',
  address_line1: 'address_line1',
  address_city: 'address_city',
  address_state: 'address_state',
  address_country: 'address_country',
  postcode: 'postal_code',
}
